<template>
  <div class="m-login">
    <!-- 顶部 Logo 区 -->
    <div class="m-login__header">
      <img src="./assets/logo.png" alt="中国品牌" class="m-login__logo" />
    </div>

    <!-- 卡片区 -->
    <div class="m-login__card">
      <!-- 账号类型切换 -->
      <div class="m-login__tabs">
        <div
          class="m-login__tab"
          :class="{ 'm-login__tab--active': accountType === 'personal' }"
          @click="switchAccountType('personal')"
        >个人账号</div>
        <div
          class="m-login__tab"
          :class="{ 'm-login__tab--active': accountType === 'company' }"
          @click="switchAccountType('company')"
        >企业账号</div>
      </div>

      <!-- 登录/注册 子标签 -->
      <div class="m-login__sub-tabs" v-if="view === 'login' || view === 'register'">
        <span
          class="m-login__sub-tab"
          :class="{ 'm-login__sub-tab--active': view === 'login' }"
          @click="switchView('login')"
        >欢迎登录</span>
        <span
          class="m-login__sub-tab"
          :class="{ 'm-login__sub-tab--active': view === 'register' }"
          @click="switchView('register')"
        >注册账号</span>
      </div>

      <!-- ============ 登录表单 ============ -->
      <div v-show="view === 'login'" class="m-login__form">
        <van-field
          v-model="loginForm.phone"
          type="tel"
          maxlength="11"
          placeholder="请输入手机号"
          left-icon="phone-o"
          clearable
          :error="!!loginForm.errors.phone"
          :error-message="loginForm.errors.phone"
          class="m-login__field"
        />
        <van-field
          v-model="loginForm.password"
          :type="showPassword ? 'text' : 'password'"
          placeholder="请输入登录密码"
          left-icon="lock"
          :right-icon="showPassword ? 'eye-o' : 'closed-eye'"
          @click-right-icon="showPassword = !showPassword"
          :error="!!loginForm.errors.password"
          :error-message="loginForm.errors.password"
          class="m-login__field m-login__field--password"
        />
        <div class="m-login__code-row">
          <van-field
            v-model="loginForm.captchaCode"
            type="text"
            maxlength="4"
            placeholder="请输入图片验证码"
            left-icon="envelop-o"
            class="m-login__field m-login__field--code"
            clearable
            :error="!!loginForm.errors.captchaCode"
            :error-message="loginForm.errors.captchaCode"
          />
          <div class="m-login__captcha-image" @click="refreshLoginCaptcha">
            <img v-if="loginCaptchaUrl" :src="loginCaptchaUrl" alt="验证码" />
            <div v-else class="captcha-placeholder">点击获取</div>
          </div>
        </div>
        <div class="m-login__options">
          <van-checkbox v-model="loginForm.autoLogin" shape="square" icon-size="14">下次自动登录</van-checkbox>
          <span class="m-login__forgot" @click="switchView('forgot')">忘记密码</span>
        </div>
        <div class="m-login__agree" @click="loginForm.agreed = !loginForm.agreed">
          <van-checkbox v-model="loginForm.agreed" shape="square" icon-size="14" />
          <span class="m-login__agree-text">我已阅读并同意 <span class="m-login__link" @click.stop="showUserAgreement = true">《用户协议》</span>和<span class="m-login__link" @click.stop="showPrivacyPolicy = true">《隐私政策》</span></span>
        </div>
        <van-button type="primary" block round color="#b0000b" class="m-login__submit" :loading="loading" @click="handleLogin">登 录</van-button>
      </div>

      <!-- ============ 注册表单 ============ -->
      <div v-show="view === 'register'" class="m-login__form">
        <van-field
          v-model="registerForm.phone"
          type="tel"
          maxlength="11"
          placeholder="请输入手机号"
          left-icon="phone-o"
          clearable
          :error="!!registerForm.errors.phone"
          :error-message="registerForm.errors.phone"
          class="m-login__field"
        />
        <!-- 图片验证码 -->
        <div class="m-login__code-row">
          <van-field
            v-model="registerForm.captchaCode"
            type="text"
            maxlength="4"
            placeholder="请输入图片验证码"
            left-icon="envelop-o"
            class="m-login__field m-login__field--code"
            clearable
            :error="!!registerForm.errors.captchaCode"
            :error-message="registerForm.errors.captchaCode"
          />
          <div class="m-login__captcha-image" @click="refreshRegisterCaptcha">
            <img v-if="registerCaptchaUrl" :src="registerCaptchaUrl" alt="验证码" />
            <div v-else class="captcha-placeholder">点击获取</div>
          </div>
        </div>
        <div class="m-login__code-row">
          <van-field
            v-model="registerForm.code"
            type="digit"
            maxlength="6"
            placeholder="请输入验证码"
            left-icon="envelop-o"
            class="m-login__field m-login__field--code"
            :error="!!registerForm.errors.code"
            :error-message="registerForm.errors.code"
          />
          <van-button
            plain
            type="primary"
            color="#b0000b"
            size="small"
            class="m-login__code-btn"
            :disabled="countdown > 0"
            @click="handleSendCode"
          >{{ countdown > 0 ? `${countdown}s` : '获取验证码' }}</van-button>
        </div>
        <van-field
          v-model="registerForm.password"
          type="password"
          placeholder="请设置登录密码"
          left-icon="lock"
          :error="!!registerForm.errors.password"
          :error-message="registerForm.errors.password"
          class="m-login__field"
        />
        <div class="m-login__pwd-hint">密码长度必须大于8位，并且是复杂密码（包含大小写字母、数字、特殊符号中的至少 2 种）</div>
        <van-field
          v-model="registerForm.confirmPassword"
          type="password"
          placeholder="请再次输入登录密码"
          left-icon="lock"
          :error="!!registerForm.errors.confirmPassword"
          :error-message="registerForm.errors.confirmPassword"
          class="m-login__field"
        />
        <van-field
          v-model="registerForm.lastName"
          :placeholder="accountType === 'personal' ? '账号昵称' : '企业名称'"
          left-icon="user-o"
          :error="!!registerForm.errors.lastName"
          :error-message="registerForm.errors.lastName"
          class="m-login__field"
        />
        <div class="m-login__agree" @click="registerForm.agreed = !registerForm.agreed">
          <van-checkbox v-model="registerForm.agreed" shape="square" icon-size="14" />
          <span class="m-login__agree-text">我已阅读并同意 <span class="m-login__link" @click.stop="showUserAgreement = true">《用户协议》</span>和<span class="m-login__link" @click.stop="showPrivacyPolicy = true">《隐私政策》</span></span>
        </div>
        <van-button type="primary" block round color="#b0000b" class="m-login__submit" :loading="loading" @click="handleRegister">注 册</van-button>
      </div>

      <!-- ============ 忘记密码 ============ -->
      <div v-show="view === 'forgot'" class="m-login__form">
        <div class="m-login__forgot-title">{{ accountType === 'company' ? '企业忘记密码' : '个人忘记密码' }}</div>
        <van-field
          v-model="forgotForm.mobile"
          type="tel"
          maxlength="11"
          placeholder="请输入注册手机号"
          left-icon="phone-o"
          clearable
          :error="!!forgotForm.errors.mobile"
          :error-message="forgotForm.errors.mobile"
          class="m-login__field"
        />
        <!-- 图片验证码 -->
        <div class="m-login__code-row">
          <van-field
            v-model="forgotForm.captchaCode"
            type="text"
            maxlength="4"
            placeholder="请输入图片验证码"
            left-icon="envelop-o"
            class="m-login__field m-login__field--code"
            clearable
          />
          <div class="m-login__captcha-image" @click="refreshForgotCaptcha">
            <img v-if="forgotCaptchaUrl" :src="forgotCaptchaUrl" alt="验证码" />
            <div v-else class="captcha-placeholder">点击获取</div>
          </div>
        </div>
        <div class="m-login__code-row">
          <van-field
            v-model="forgotForm.code"
            type="digit"
            maxlength="6"
            placeholder="请输入短信验证码"
            left-icon="envelop-o"
            class="m-login__field m-login__field--code"
          />
          <van-button
            plain
            type="primary"
            color="#b0000b"
            size="small"
            class="m-login__code-btn"
            :disabled="countdown > 0"
            @click="handleSendCode"
          >{{ countdown > 0 ? `${countdown}s` : '获取验证码' }}</van-button>
        </div>
        <van-field
          v-model="forgotForm.password"
          type="password"
          placeholder="请输入新的登录密码"
          left-icon="lock"
          class="m-login__field"
        />
        <van-field
          v-model="forgotForm.confirmPassword"
          type="password"
          placeholder="请再次输入登录密码"
          left-icon="lock"
          :error="!!forgotForm.errors.code"
          :error-message="forgotForm.errors.code"
          class="m-login__field"
        />
        <div class="m-login__pwd-hint">密码长度必须大于8位，并且是复杂密码（包含大小写字母、数字、特殊符号中的至少 2 种）</div>
        <van-button type="primary" block round color="#b0000b" class="m-login__submit" :loading="loading" @click="handleForgotSubmit">提 交</van-button>
        <div class="m-login__back" @click="switchView('login')">返回登录</div>
      </div>

      <!-- ============ 注册成功 ============ -->
      <div v-show="view === 'success'" class="m-login__success">
        <van-icon name="checked" size="64" color="#07c160" />
        <div class="m-login__success-title">恭喜您，注册成功</div>
        <div class="m-login__success-sub">{{ redirectCountdown }}S后自动跳转</div>
        <van-button type="primary" block round color="#b0000b" class="m-login__submit" @click="goProfile">
          {{ accountType === 'personal' ? '完善个人资料' : '快去完善企业资料，发布资讯' }}
        </van-button>
      </div>

      <!-- 用户协议弹窗 -->
      <van-popup v-model="showUserAgreement" position="bottom" round :style="{ height: '85%' }" closeable>
        <div class="m-login__agreement-popup">
          <div class="m-login__agreement-header">用户协议</div>
          <div class="m-login__agreement-body">
            <h1>用户协议</h1>
            <div class="meta-info"><span>生效日期：2026-09-15</span><span>最后更新：2026-09-15</span></div>
            <div class="highlight-box"><strong>【特别提示】</strong> 在使用中国品牌网所提供的各项服务之前，请您务必仔细阅读并透彻理解本《用户协议》。当您按照页面提示完成全部注册/勾选同意/开始使用流程后，即表示您已充分阅读、理解并接受本协议的全部内容。如您不同意本协议的任何条款，请您立即停止使用本平台服务。</div>
            <div class="info-box">本平台由《中国品牌》杂志社有限责任公司运营，主办单位为中国品牌建设促进会，主管单位为国家市场监督管理总局。</div>
            <h2>一、协议主体与适用范围</h2>
            <p><strong>1.1</strong> 本协议由您与《中国品牌》杂志社有限责任公司共同订立，适用于您访问、使用本平台所提供的全部服务。</p>
            <p><strong>1.2</strong> 本平台涉及的具体服务可能另有单独的协议、规则等，该等规则一经发布即为本协议不可分割的组成部分。</p>
            <p><strong>1.3</strong> 我们保留随时修改本协议的权利，修改后的协议在本平台公布后即代替原协议生效。</p>
            <h2>二、相关定义</h2>
            <p><strong>2.1</strong> “本平台”指由《中国品牌》杂志社有限责任公司运营的官方网站及关联移动端、微信公众号等。</p>
            <p><strong>2.2</strong> “用户”指访问、浏览或使用本平台服务的任何自然人、法人或其他组织。</p>
            <p><strong>2.3</strong> “账号”指用户在本平台注册的、用于识别用户身份的唯一标识。</p>
            <h2>三、服务内容</h2>
            <p>本平台主要提供以下服务：</p>
            <p><strong>3.1</strong> 品牌资讯发布与浏览服务：包括但不限于资讯、视频、专题、人物、案例等领域资讯的发布、转载与浏览。</p>
            <p><strong>3.2</strong> 品牌影响力指数服务：包括品牌价值评价指数的查询、研究与发布。</p>
            <p><strong>3.3</strong> 融媒集群服务：包括微博、微信公众号、抖音号等矩阵账号的资讯分发服务。</p>
            <p><strong>3.4</strong> 品牌活动服务：包括会议、论坛、调研、沙龙等活动的组织与参与服务。</p>
            <p><strong>3.5</strong> 品牌研究服务：包括课题研究、调研研讨、指数发布、行业报告等服务。</p>
            <p><strong>3.6</strong> 广告与营销服务：包括广告设计、制作及发布，营销策划，技术推广等服务。</p>
            <h2>四、用户注册与账号管理</h2>
            <p><strong>4.1</strong> 您应具备与注册行为相适应的民事行为能力。</p>
            <p><strong>4.2</strong> 您应按照平台页面引导真实、准确、完整地提供注册信息，不得冒用、盗用他人身份信息。</p>
            <p><strong>4.3</strong> 您应妥善保管账号、密码及验证码，因未妥善保管所导致的一切后果由您自行承担。</p>
            <p><strong>4.4</strong> 如需注销账号，可通过本平台公布的联系方式与我们联系。</p>
            <h2>五、用户行为规范</h2>
            <p>您在使用本平台服务时，应严格遵守法律法规、社会公德及本协议约定，不得从事下列行为：</p>
            <ol>
              <li>违反宪法确定的基本原则，危害国家安全、荣誉和利益；</li>
              <li>损害国家荣誉和利益，歪曲、丑化、亵渎英雄烈士事迹和精神；</li>
              <li>宣扬恐怖主义、极端主义、仇恨言论，煽动民族仇恨、歧视；</li>
              <li>散布谣言、虚假信息，扰乱经济秩序和社会秩序；</li>
              <li>侮辱、诽谤他人，侵害他人合法权益；</li>
              <li>发布、传播淫秽、色情、赌博、暴力等不良内容；</li>
              <li>侵犯他人著作权、商标权、专利权等知识产权；</li>
              <li>虚构事实，发布虚假品牌资讯、企业信息；</li>
              <li>发布广告、垃圾、骚扰信息，从事不正当竞争；</li>
              <li>通过技术手段批量注册、刷量、恶意占用资源；</li>
              <li>利用技术手段攻击、破解、篡改本平台系统或数据；</li>
              <li>其他违反法律法规或本协议的行为。</li>
            </ol>
            <h2>六、用户内容与知识产权</h2>
            <p><strong>6.1</strong> 您发布的内容，其知识产权仍归您或合法权利人所有，但您应保证拥有合法发布权。</p>
            <p><strong>6.2</strong> 本平台全部内容的知识产权归我们或合法权利人所有，未经许可不得复制、转载、修改、传播或用于商业目的。</p>
            <p><strong>6.3</strong> 您授予我们全球范围内、非独家、免许可费、永久的许可，用于本平台及融媒集群的展示、传播、推广等合理使用。</p>
            <h2>七、个人(企业)信息保护</h2>
            <p><strong>7.1</strong> 保护您的个人(企业)信息是我们的基本原则，详见本平台《隐私条款》。</p>
            <p><strong>7.2</strong> 您应保证提供的信息已获得相关当事人的合法授权或同意。</p>
            <h2>八、广告与第三方服务</h2>
            <p><strong>8.1</strong> 本平台可能展示第三方广告，我们不对广告内容的真实性、合法性作出保证。</p>
            <p><strong>8.2</strong> 本平台可能包含第三方链接，我们不对第三方网站的内容、政策承担任何责任。</p>
            <h2>九、免责声明</h2>
            <p><strong>9.1</strong> 本平台内容仅供参考，不构成任何专业建议或意见。</p>
            <p><strong>9.2</strong> 我们不对服务的及时性、安全性、准确性、可用性作出任何保证。</p>
            <p><strong>9.3</strong> 因不可抗力、您自身设备问题、第三方原因、您违反协议等情形导致损失的，我们不承担责任。</p>
            <p><strong>9.4</strong> 我们有权随时对平台服务进行变更、中止或终止。</p>
            <h2>十、违约责任</h2>
            <p><strong>10.1</strong> 如您违反本协议，我们有权采取警告、限制功能、暂停服务、封禁账号、删除内容、追究法律责任等措施。</p>
            <p><strong>10.2</strong> 如您的行为给我们或第三方造成损失的，您应依法承担赔偿责任。</p>
            <h2>十一、协议变更与终止</h2>
            <p><strong>11.1</strong> 我们有权根据需要修改本协议，修改后一经发布即生效。</p>
            <p><strong>11.2</strong> 您注销账号或我们终止运营时，本协议终止。</p>
            <h2>十二、法律适用与争议解决</h2>
            <p><strong>12.1</strong> 本协议适用中华人民共和国法律法规。</p>
            <p><strong>12.2</strong> 争议应首先协商解决，协商不成可提交本公司所在地有管辖权的人民法院诉讼解决。</p>
            <h2>十三、联系我们</h2>
            <p><strong>运营主体：</strong>《中国品牌》杂志社有限责任公司</p>
            <p><strong>办公地址：</strong>北京市朝阳区北三环东路 18 号院 6 号楼</p>
            <p><strong>联系电话：</strong>010-65283638</p>
            <p><strong>电子邮箱：</strong>bd@cbrand.com.cn</p>
            <p><strong>官方网站：</strong>https://www.cbrand.com.cn</p>
            <h2>十四、其他</h2>
            <p><strong>14.1</strong> 本协议自您点击同意或开始使用本平台服务之日起生效。</p>
            <p><strong>14.2</strong> 本协议所有条款的标题仅为阅读方便，本身并无实际含义，不能作为本协议相关条款解释的依据。</p>
            <p><strong>14.3</strong> 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对各方具有约束力。</p>
            <p><strong>14.4</strong> 本协议不构成任何劳动、雇佣、代理、合伙、特许经营等法律关系。</p>
            <p><strong>14.5</strong> 本协议未尽事宜，按照中华人民共和国相关法律法规及行业惯例执行。</p>
            <div class="highlight-box" style="margin-top:16px"><p>请您再次确认：您已经仔细阅读、充分理解并接受本《用户协议》的全部条款。如您不同意本协议的任何条款，请立即停止使用本平台服务。</p></div>
            <p style="text-align:center;color:#999;font-size:12px;margin-top:16px">© 版权所有《中国品牌》杂志社有限责任公司 保留一切权利</p>
          </div>
        </div>
      </van-popup>

      <!-- 隐私政策弹窗 -->
      <van-popup v-model="showPrivacyPolicy" position="bottom" round :style="{ height: '85%' }" closeable>
        <div class="m-login__agreement-popup">
          <div class="m-login__agreement-header">隐私政策</div>
          <div class="m-login__agreement-body">
            <h1>隐私政策</h1>
            <div class="meta-info"><span>生效日期：2026-09-15</span><span>最后更新：2026-09-15</span></div>
            <div class="highlight-box"><strong>【特别提示】</strong> 中国品牌网（由《中国品牌》杂志社有限责任公司运营）非常重视您的个人(企业)信息保护。请您在使用我们的服务前，仔细阅读并透彻理解本《隐私条款》。您使用或继续使用我们的服务，即表示您同意我们按照本条款处理您的相关信息。</div>
            <div class="info-box">本平台由《中国品牌》杂志社有限责任公司运营，主办单位为中国品牌建设促进会，主管单位为国家市场监督管理总局。</div>
            <h2>一、适用范围</h2>
            <p><strong>1.1</strong> 本条款适用于您使用本平台服务过程中，我们对您个人(企业)信息的收集、使用、存储、共享等活动。</p>
            <p><strong>1.2</strong> 本条款不适用于通过本平台接入的第三方独立运营的网站或服务。</p>
            <h2>二、我们如何收集和使用您的信息</h2>
            <p><strong>2.1 收集的信息类型</strong></p>
            <p><strong>（一）注册、登录与账号管理</strong></p>
            <p>手机号码、电子邮箱、用户名、密码（加密存储）、头像、昵称、所在地区等。</p>
            <p><strong>（二）使用服务过程中</strong></p>
            <p>浏览记录、搜索记录、点击记录、评论内容、设备信息、日志信息（IP地址、访问时间）、Cookie等。</p>
            <p><strong>（三）参加品牌活动或合作项目</strong></p>
            <p>姓名、单位、职务、联系方式、身份证件信息（仅在必要场景）、合作需求等。</p>
            <p><strong>（四）广告与营销服务</strong></p>
            <p>单位信息、联系人信息、银行账户或发票信息等。</p>
            <p><strong>（五）客户服务与投诉处理</strong></p>
            <p>姓名、联系方式、问题描述、沟通记录等。</p>
            <p><strong>（六）保障账号与服务安全</strong></p>
            <p>设备信息、日志信息、位置信息（经您授权时）等。</p>
            <p><strong>2.2 使用目的</strong></p>
            <ol>
              <li>为您提供各项服务，并维护、改进、优化这些服务；</li>
              <li>注册账号、验证身份、维护账号安全；</li>
              <li>推送您可能感兴趣的资讯、活动通知、合作信息；</li>
              <li>开展品牌影响力评价、品牌研究等学术研究工作；</li>
              <li>开展市场调研、客户满意度调查；</li>
              <li>响应您的咨询、意见与投诉；</li>
              <li>履行法律法规规定的义务；</li>
              <li>防范安全风险，识别、阻止欺诈、违法违规行为；</li>
              <li>经您授权或同意的其他用途。</li>
            </ol>
            <p><strong>2.3 依法不需要取得您同意的例外</strong></p>
            <ol>
              <li>为订立、履行合同所必需的；</li>
              <li>为履行法定职责或法定义务所必需的；</li>
              <li>为应对突发公共卫生事件或紧急情况下保护生命财产安全所必需的；</li>
              <li>收集您自行向社会公众公开的信息；</li>
              <li>法律法规规定的其他情形。</li>
            </ol>
            <h2>三、Cookie 与同类技术</h2>
            <p><strong>3.1</strong> 我们使用 Cookie 及同类技术来记住您的身份、了解您的使用偏好、提升访问体验。</p>
            <p><strong>3.2</strong> 使用的 Cookie 类型包括：必要 Cookie（维持登录状态、保障安全）、偏好 Cookie（记住偏好设置）、统计 Cookie（统计运营数据）、营销 Cookie（展示相关广告）。</p>
            <p><strong>3.3</strong> 您可以通过浏览器设置管理或删除 Cookie，但可能影响部分功能的使用。</p>
            <h2>四、我们如何共享、转让、公开披露您的信息</h2>
            <p><strong>4.1 共享</strong>——我们不会主动与第三方共享您的信息，以下情形除外：</p>
            <ol>
              <li>事先获得您的明确同意；</li>
              <li>与关联实体共享以提供一致化服务；</li>
              <li>与合作机构共享必要的报名信息；</li>
              <li>向广告主提供去标识化或匿名化后的统计数据；</li>
              <li>委托具备合法资质的第三方服务商处理；</li>
              <li>法律法规要求或主管部门依法要求。</li>
            </ol>
            <p><strong>4.2 转让</strong>——我们不会主动转让您的信息，运营主体合并时除外。</p>
            <p><strong>4.3 公开披露</strong>——原则上不会公开披露，除非获得您的明确同意或法律法规要求。</p>
            <h2>五、我们如何存储和保护您的信息</h2>
            <p><strong>5.1</strong> 在中国境内收集和产生的信息，将存储在中国境内。</p>
            <p><strong>5.2</strong> 仅在提供服务所必需的最短期间内保留您的信息。账号信息在使用期间持续保存；日志信息原则上保留不超过 6 个月。</p>
            <p><strong>5.3</strong> 安全保护措施包括：SSL/TLS 加密传输、分级存储与访问控制、身份认证、安全审计、应急预案、人员保密协议等。</p>
            <p><strong>5.4</strong> 如发生信息安全事件，我们将及时通过页面公告、短信、邮件等方式告知您。</p>
            <h2>六、您的权利</h2>
            <p><strong>6.1 查询、复制权</strong>——您有权查询、复制您的信息，我们将在 15 个工作日内回复。</p>
            <p><strong>6.2 更正、补充权</strong>——信息有错误或不完整的，您有权要求更正或补充。</p>
            <p><strong>6.3 删除权</strong>——在目的已实现、您撤回同意等情形下，您有权要求删除。</p>
            <p><strong>6.4 撤回同意权</strong>——您有权随时撤回同意，不影响撤回前的处理活动。</p>
            <p><strong>6.5 注销账号权</strong>——您有权注销账号，注销后我们将删除或匿名化处理您的信息。</p>
            <p><strong>6.6</strong> 我们将在收到请求后 15 个工作日内予以核查并回复。</p>
            <h2>七、未成年人保护</h2>
            <p><strong>7.1</strong> 本平台主要面向专业用户，原则上不直接面向 14 周岁以下未成年人。</p>
            <p><strong>7.2</strong> 14 周岁以上未成年人使用本平台前，应由监护人同意。</p>
            <p><strong>7.3</strong> 不满 14 周岁的儿童，请勿向我们提供个人信息。</p>
            <h2>八、第三方服务与链接</h2>
            <p><strong>8.1</strong> 本平台可能包含跳转至第三方网站的链接，我们不对第三方平台的内容、政策承担责任。</p>
            <p><strong>8.2</strong> 本平台可能嵌入第三方组件、SDK、API，第三方可能基于功能需要收集您的部分信息。</p>
            <h2>九、条款变更</h2>
            <p><strong>9.1</strong> 我们保留随时修订本条款的权利，修订后一经发布即生效。</p>
            <p><strong>9.2</strong> 重大变更将以显著方式告知您。</p>
            <p><strong>9.3</strong> 如您不同意修订后的条款，您有权停止使用。</p>
            <h2>十、联系我们</h2>
            <p><strong>运营主体：</strong>《中国品牌》杂志社有限责任公司</p>
            <p><strong>办公地址：</strong>北京市朝阳区北三环东路 18 号院 6 号楼</p>
            <p><strong>联系电话：</strong>010-65283638</p>
            <p><strong>电子邮箱：</strong>bd@cbrand.com.cn</p>
            <p><strong>官方网站：</strong>https://www.cbrand.com.cn</p>
            <p>我们将在收到您的反馈后 15 个工作日内予以回复处理。</p>
            <h2>十一、其他</h2>
            <p><strong>11.1</strong> 本《隐私条款》自您点击同意或开始使用本平台服务之日起生效。</p>
            <p><strong>11.2</strong> 本《隐私条款》的订立、执行、解释及争议解决均适用中华人民共和国法律法规。如本《隐私条款》与《用户协议》就同一事项存在不一致的，以本《隐私条款》为准；如本《隐私条款》未约定的，按《用户协议》执行。</p>
            <p><strong>11.3</strong> 本《隐私条款》中所有条款的标题仅为阅读方便，本身并无实际含义，不能作为本《隐私条款》相关条款解释的依据。</p>
            <p><strong>11.4</strong> 本《隐私条款》所有条款无论因何种原因部分无效或不可执行，其余条款仍有效，对各方具有约束力。</p>
            <div class="highlight-box" style="margin-top:16px"><p>请您再次确认：您已经仔细阅读、充分理解并接受本《隐私条款》的全部条款。如您不同意本《隐私条款》的任何条款，请立即停止使用本平台服务。</p></div>
            <p style="text-align:center;color:#999;font-size:12px;margin-top:16px">© 版权所有《中国品牌》杂志社有限责任公司 保留一切权利</p>
          </div>
        </div>
      </van-popup>

    </div>

  </div>
</template>

<script>
import { Toast } from 'vant'
import mobileViewport from './mixins/viewport'
import {
  memberLogin,
  companyLogin,
  memberRegister,
  companyRegister,
  memberGetMessage,
  companyGetMessage,
  memberResetPassword,
  companyResetPassword,
  getCaptchaImage
} from '../../api/login'
import CryptoJS from 'crypto-js'

export default {
  mixins: [mobileViewport],
  name: 'MobileLogin',
  data() {
    return {
      accountType: 'personal',
      view: 'login',
      showPassword: false,
      loading: false,
      countdown: 0,
      timer: null,
      redirectCountdown: 5,
      redirectTimer: null,
      wechatCode: '', // 微信授权返回的 code
      loginForm: {
        phone: '',
        password: '',
        autoLogin: false,
        agreed: false,
        captchaCode: '',
        uuid: '',
        errors: { phone: '', password: '', captchaCode: '' }
      },
      loginError: '',
      registerForm: {
        phone: '',
        code: '',
        password: '',
        confirmPassword: '',
        lastName: '',
        agreed: false,
        captchaCode: '',
        uuid: '',
        errors: { phone: '', code: '', password: '', confirmPassword: '', lastName: '', captchaCode: '' }
      },
      forgotForm: {
        mobile: '',
        code: '',
        password: '',
        confirmPassword: '',
        captchaCode: '',
        uuid: '',
        errors: { mobile: '', code: '', captchaCode: '' }
      },
      // AES 加密密钥（必须与后端完全一致）
      SECRET_KEY: 'zp_base_aes_2026',
      loginCaptchaUrl: '',   // 登录验证码图片 URL
      registerCaptchaUrl: '', // 注册验证码图片 URL
      forgotCaptchaUrl: '',  // 忘记密码验证码图片 URL
      showUserAgreement: false,
      showPrivacyPolicy: false
    }
  },
  created() {
    // 从 URL 参数中获取微信授权 code
    const code = this.$route.query.code;
    if (code) {
      this.wechatCode = code;
    }
    console.log('MobileLogin created, wechatCode:', this.wechatCode);
  },
  mounted() {
    console.log('MobileLogin mounted, starting loadLoginCaptcha');
    this.loadLoginCaptcha();
    // 如果 URL 中有 redirect 参数且没有 code，自动跳转微信授权
    if (!this.wechatCode && this.isWeChat()) {
      // 微信授权回调地址：直接回跳到当前登录页（带上原始的 redirect 参数）
      let redirectUrl = window.location.origin + '/login';
      
      // 如果有原始的 redirect 参数，要保留在 URL 中
      if (this.$route.query.redirect) {
        redirectUrl += `?redirect=${encodeURIComponent(this.$route.query.redirect)}`;
      }
      
      const appId = process.env.VUE_APP_WECHAT_APPID || 'wxc8c3e91624cb8fd8';
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(redirectUrl)}&response_type=code&scope=snsapi_base#wechat_redirect`;
    }
  },
  beforeDestroy() {
    this.clearTimers()
  },
  methods: {
    /**
     * AES-ECB-PKCS7Padding 加密方法
     * @param {string} text - 明文文本
     * @returns {string} Base64 编码后的密文
     */
    encryptPassword(text) {
      try {
        // 将字符串转换为 UTF-8 字节数组
        const wordArray = CryptoJS.enc.Utf8.parse(text);
        
        // 使用 ECB 模式和 PKCS7 填充
        const key = CryptoJS.enc.Utf8.parse(this.SECRET_KEY)
        const encrypted = CryptoJS.AES.encrypt(wordArray, key, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        })
        
        // 返回 Base64 编码的密文
        return encrypted.toString()
      } catch (error) {
        console.error('加密失败:', error)
        throw new Error('密码加密失败')
      }
    },
    // 加载登录验证码
    async loadLoginCaptcha() {
      try {
        console.log('Loading login captcha, getCaptchaImage:', typeof getCaptchaImage);
        const res = await getCaptchaImage()
        console.log('Get captcha response:', res)
        if (res.code === 200) {
          this.loginForm.uuid = res.uuid || ''
          this.loginCaptchaUrl = `data:image/png;base64,${res.img}`
          console.log('Login captcha URL set:', this.loginCaptchaUrl.substring(0, 50) + '...')
        } else {
          console.error('Get captcha failed:', res)
        }
      } catch (e) {
        console.error('Load captcha error:', e)
      }
    },
    // 加载注册验证码
    async loadRegisterCaptcha() {
      try {
        const res = await getCaptchaImage()
        if (res.code === 200) {
          this.registerForm.uuid = res.uuid || ''
          this.registerCaptchaUrl = `data:image/png;base64,${res.img}`
        }
      } catch (e) {
        console.error('注册验证码加载失败', e)
      }
    },
    // 加载忘记密码验证码
    async loadForgotCaptcha() {
      try {
        const res = await getCaptchaImage()
        if (res.code === 200) {
          this.forgotForm.uuid = res.uuid || ''
          this.forgotCaptchaUrl = `data:image/png;base64,${res.img}`
        }
      } catch (e) {
        console.error('忘记密码验证码加载失败', e)
      }
    },
    // 点击刷新登录验证码
    refreshLoginCaptcha() {
      this.loadLoginCaptcha()
    },
    // 点击刷新注册验证码
    refreshRegisterCaptcha() {
      this.loadRegisterCaptcha()
    },
    // 点击刷新忘记密码验证码
    refreshForgotCaptcha() {
      this.loadForgotCaptcha()
    },
    // 发送短信验证码
    switchAccountType(type) {
      this.accountType = type
    },
    switchView(view) {
      this.view = view
      this.loginError = ''
      this.loginForm.errors = { phone: '', password: '', captchaCode: '' }
      this.registerForm.errors = { phone: '', code: '', password: '', confirmPassword: '', lastName: '', captchaCode: '' }
      this.forgotForm.errors = { mobile: '', code: '', captchaCode: '' }
      
      // 切换视图时刷新对应的验证码
      if (view === 'login') {
        this.loadLoginCaptcha()
      } else if (view === 'register') {
        this.loadRegisterCaptcha()
      } else if (view === 'forgot') {
        this.loadForgotCaptcha()
      }
    },
    clearTimers() {
      if (this.timer) { clearInterval(this.timer); this.timer = null }
      if (this.redirectTimer) { clearInterval(this.redirectTimer); this.redirectTimer = null }
    },
    startCountdown() {
      this.countdown = 60
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) { clearInterval(this.timer); this.timer = null }
      }, 1000)
    },
    startRedirectCountdown() {
      this.redirectCountdown = 5
      const redirect = this.$route.query.redirect
      const targetPath = redirect || '/my'
      this.redirectTimer = setInterval(() => {
        this.redirectCountdown--
        if (this.redirectCountdown <= 0) {
          clearInterval(this.redirectTimer)
          this.redirectTimer = null
          this.$router.push(targetPath)
        }
      }, 1000)
    },
    // 发送短信验证码
    async handleSendCode() {
      if (this.countdown > 0) return
      const isRegister = this.view === 'register'
      const phone = isRegister ? this.registerForm.phone : this.forgotForm.mobile
      const errorField = isRegister ? 'registerForm' : 'forgotForm'
      const errorKey = isRegister ? 'phone' : 'mobile'

      if (!phone || !/^1[3-9]\d{9}$/.test(phone)) {
        this[errorField].errors[errorKey] = '请输入正确的手机号'
        return
      }
      this[errorField].errors[errorKey] = ''

      try {
        const api = this.accountType === 'personal' ? memberGetMessage : companyGetMessage
        // 根据当前视图获取对应的 UUID 和图片验证码
        let captchaData = {}
        if (this.view === 'register') {
          captchaData = {
            uuid: this.registerForm.uuid,
            captchaCode: this.registerForm.captchaCode
          }
        } else if (this.view === 'forgot') {
          captchaData = {
            uuid: this.forgotForm.uuid,
            captchaCode: this.forgotForm.captchaCode
          }
        }
        // 添加 messageType 参数：1-注册、3-忘记密码
        const messageType = isRegister ? 1 : 3
        await api({ areaCode: '86', mobile: phone, messageType, ...captchaData })
        this.startCountdown()
        Toast('验证码已发送')
        // 根据当前视图刷新对应的图片验证码
        if (this.view === 'register') {
          this.loadRegisterCaptcha()
        } else if (this.view === 'forgot') {
          this.loadForgotCaptcha()
        }
      } catch (e) {
        // 根据当前视图刷新对应的图片验证码
        if (this.view === 'register') {
          this.loadRegisterCaptcha()
        } else if (this.view === 'forgot') {
          this.loadForgotCaptcha()
        }
        Toast(this.getErrorMsg(e, '验证码发送失败，请稍后重试'))
      }
    },
    // 登录
    async handleLogin() {
      this.loginForm.errors = { phone: '', password: '' }
      if (!this.loginForm.phone) { this.loginForm.errors.phone = '请输入手机号'; return }
      if (!/^1[3-9]\d{9}$/.test(this.loginForm.phone)) { this.loginForm.errors.phone = '请输入正确的手机号'; return }
      if (!this.loginForm.password) { this.loginForm.errors.password = '请输入登录密码'; return }
      
      // 图片验证码验证
      if (!this.loginForm.captchaCode) {
        this.loginForm.errors.captchaCode = '请输入图片验证码'
        return
      }
      
      // 协议勾选验证
      if (!this.loginForm.agreed) {
        Toast({ message: '请先阅读并同意用户协议和隐私政策', duration: 2000 })
        // 滚动到协议勾选区域
        const agreeEl = this.$el.querySelector('.m-login__agree')
        if (agreeEl) {
          agreeEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
        return
      }

      // 对密码进行 AES 加密
      let encryptedPassword
      try {
        encryptedPassword = this.encryptPassword(this.loginForm.password)
      } catch (e) {
        this.loginForm.errors.password = '密码加密失败，请重试'
        Toast('密码加密失败，请重试')
        return
      }

      this.loading = true
      const params = {
        loginName: this.loginForm.phone,
        password: encryptedPassword,
        loginType: 1,
        uuid: this.loginForm.uuid,
        captchaCode: this.loginForm.captchaCode
      }
      // 如果有的话，加入微信授权 code
      if (this.wechatCode) {
        params.wxCode = this.wechatCode
      }
      try {
        const res = this.accountType === 'personal'
          ? await memberLogin(params)
          : await companyLogin(params)

        const data = res.data || {}
        localStorage.setItem('token', data.token || '')
        localStorage.setItem('userType', this.accountType)
        localStorage.setItem('userInfo', JSON.stringify(data))

        const redirect = this.$route.query.redirect
        this.$router.push(redirect || '/my')
      } catch (e) {
        const msg = this.getErrorMsg(e, '登录失败')
        this.loginError = msg
        this.loadLoginCaptcha()
        Toast(msg)
      } finally {
        this.loading = false
      }
    },
    /**
     * 验证密码格式：长度 8-20 位，至少包含两种字符类型
     * @returns {{password: string, confirmPassword: string}} 密码框与确认密码框各自的错误信息，空字符串表示通过
     */
    validatePasswordFormat(password, confirmPassword) {
      const errors = { password: '', confirmPassword: '' }
      if (!password) {
        errors.password = '请输入密码'
        return errors
      }
      if (password.length < 8 || password.length > 20) {
        errors.password = '密码长度必须在 8-20 个字符之间'
        return errors
      }
      
      const hasUpper = /[A-Z]/.test(password)
      const hasLower = /[a-z]/.test(password)
      const hasDigit = /\d/.test(password)
      const hasSpecial = /[!@#$%^&*()_+=\-{}[\];':"\\|,.<>?~`]/.test(password)
      
      const typeCount = [hasUpper, hasLower, hasDigit, hasSpecial].filter(Boolean).length
      if (typeCount < 2) {
        errors.password = '密码必须包含至少两种字符类型 (大小写字母、数字、特殊符号)'
        return errors
      }
      
      if (password !== confirmPassword) {
        errors.confirmPassword = '两次密码输入不一致'
      }
      return errors
    },
    // 注册
    async handleRegister() {
      this.registerForm.errors = { phone: '', code: '', password: '', confirmPassword: '', lastName: '', captchaCode: '' }
      if (!this.registerForm.phone) { this.registerForm.errors.phone = '请输入手机号'; return }
      if (!/^1[3-9]\d{9}$/.test(this.registerForm.phone)) { this.registerForm.errors.phone = '请输入正确的手机号'; return }
      if (!this.registerForm.code) { this.registerForm.errors.code = '请输入验证码'; return }
      
      // 密码格式验证
      const pwdErrors = this.validatePasswordFormat(this.registerForm.password, this.registerForm.confirmPassword)
      if (pwdErrors.password || pwdErrors.confirmPassword) {
        this.registerForm.errors.password = pwdErrors.password
        this.registerForm.errors.confirmPassword = pwdErrors.confirmPassword
        return
      }
      
      if (!this.registerForm.lastName) { this.registerForm.errors.lastName = this.accountType === 'personal' ? '请输入账号昵称' : '请输入企业名称'; return }
      if (!this.registerForm.agreed) { Toast({ message: '请先阅读并同意用户协议和隐私政策', duration: 2000 }); return }
      
      // 图片验证码验证
      if (!this.registerForm.captchaCode) {
        this.registerForm.errors.captchaCode = '请输入图片验证码'
        return
      }

      this.loading = true
      try {
        let res
        if (this.accountType === 'personal') {
          // 对密码进行 AES 加密
          let encryptedPassword
          try {
            encryptedPassword = this.encryptPassword(this.registerForm.password)
          } catch (e) {
            this.registerForm.errors.password = '密码加密失败，请稍后重试'
            Toast('密码加密失败，请稍后重试')
            return
          }

          res = await memberRegister({
            mobile: this.registerForm.phone,
            smsCode: this.registerForm.code,
            password: encryptedPassword,
            nickname: this.registerForm.lastName,
            uuid: this.registerForm.uuid,
            captchaCode: this.registerForm.captchaCode,
            ...(this.wechatCode && { wxCode: this.wechatCode }) // 如果有微信 code，传递给接口
          })
        } else {
          // 对密码进行 AES 加密
          let encryptedPassword
          try {
            encryptedPassword = this.encryptPassword(this.registerForm.password)
          } catch (e) {
            this.registerForm.errors.password = '密码加密失败，请稍后重试'
            Toast('密码加密失败，请稍后重试')
            return
          }

          res = await companyRegister({
            companyName: this.registerForm.lastName,
            loginName: this.registerForm.phone,
            password: encryptedPassword,
            smsCode: this.registerForm.code,
            uuid: this.registerForm.uuid,
            captchaCode: this.registerForm.captchaCode,
            ...(this.wechatCode && { wxCode: this.wechatCode }) // 如果有微信 code，传递给接口
          })
        }
        const data = (res && res.data) || {}
        if (data.token) localStorage.setItem('token', data.token)
        localStorage.setItem('userType', this.accountType)
        if (data.userInfo) localStorage.setItem('userInfo', JSON.stringify(data.userInfo))

        this.view = 'success'
        this.startRedirectCountdown()
      } catch (e) {
        const msg = this.getErrorMsg(e, '注册失败，请稍后重试')
        this.registerForm.errors.code = msg
        Toast(msg)
      } finally {
        this.loading = false
      }
    },
    // 忘记密码提交
    async handleForgotSubmit() {
      this.forgotForm.errors = { mobile: '', code: '', captchaCode: '' }
      if (!this.forgotForm.mobile) { this.forgotForm.errors.mobile = '请输入手机号'; return }
      if (!/^1[3-9]\d{9}$/.test(this.forgotForm.mobile)) { this.forgotForm.errors.mobile = '请输入正确的手机号'; return }
      if (!this.forgotForm.code) { this.forgotForm.errors.code = '请输入验证码'; return }
      
      // 密码格式验证
      const pwdErrors = this.validatePasswordFormat(this.forgotForm.password, this.forgotForm.confirmPassword)
      if (pwdErrors.password || pwdErrors.confirmPassword) {
        this.forgotForm.errors.code = pwdErrors.password || pwdErrors.confirmPassword
        return
      }
      
      // 图片验证码验证
      if (!this.forgotForm.captchaCode) {
        this.forgotForm.errors.captchaCode = '请输入图片验证码'
        return
      }

      this.loading = true
      try {
        const api = this.accountType === 'personal' ? memberResetPassword : companyResetPassword
        // 对密码进行 AES 加密
        let encryptedPassword
        try {
          encryptedPassword = this.encryptPassword(this.forgotForm.password)
        } catch (e) {
          this.forgotForm.errors.code = '密码加密失败，请稍后重试'
          Toast('密码加密失败，请稍后重试')
          return
        }
        
        await api({
          mobile: this.forgotForm.mobile,
          smsCode: this.forgotForm.code,
          password: encryptedPassword,
          uuid: this.forgotForm.uuid,
          captchaCode: this.forgotForm.captchaCode
        })
        Toast('密码修改成功！')
        this.view = 'login'
      } catch (e) {
        const msg = this.getErrorMsg(e, '密码修改失败')
        Toast(msg)
      } finally {
        this.loading = false
      }
    },
    goProfile() {
      this.clearTimers()
      const redirect = this.$route.query.redirect
      this.$router.push(redirect || '/my')
    },
    // 检测是否是微信环境
    isWeChat() {
      const ua = navigator.userAgent.toLowerCase();
      return /micromessenger/.test(ua);
    },
    thirdLogin(type) {
      Toast(`${type}登录暂未开通`)
    },
    getErrorMsg(e, defaultMsg) {
      if (!e) return defaultMsg
      if (e.response && e.response.data) {
        const data = e.response.data
        if (typeof data === 'string') return data
        return data.msg || data.message || defaultMsg
      }
      return e.message || defaultMsg
    }
  }
}
</script>

<style scoped>
.m-login {
  min-height: 100vh;
  background: linear-gradient(180deg, #E8F4FD 0%, #F0F7FF 40%, #FFFFFF 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 24px;
  padding-bottom: env(safe-area-inset-bottom);
  box-sizing: border-box;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* ========== Header ========== */
.m-login__header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 60px;
  margin-bottom: 28px;
}

.m-login__logo {
  width: 40%;
  height: auto;
  object-fit: contain;
}

.m-login__subtitle {
  display: none;
}

/* ========== Card ========== */
.m-login__card {
  width: 100%;
  background: #fff;
  border-radius: 20px;
  padding: 24px 20px;
  box-shadow: 0 4px 24px rgba(0, 145, 234, 0.08);
  box-sizing: border-box;
}

/* ========== 账号类型 Tabs ========== */
.m-login__tabs {
  display: flex;
  background: #F0F5FA;
  border-radius: 22px;
  padding: 3px;
  margin-bottom: 20px;
}

.m-login__tab {
  flex: 1;
  text-align: center;
  padding: 8px 0;
  font-size: 14px;
  font-weight: 500;
  color: #888;
  border-radius: 20px;
  transition: all 0.25s;
}

.m-login__tab--active {
  background: #fff;
  color: #0091EA;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(0, 145, 234, 0.12);
}

/* ========== 登录/注册子标签 ========== */
.m-login__sub-tabs {
  display: flex;
  gap: 28px;
  margin-bottom: 20px;
}

.m-login__sub-tab {
  position: relative;
  font-size: 17px;
  font-weight: 500;
  color: #bbb;
  padding-bottom: 8px;
  transition: color 0.25s;
}

.m-login__sub-tab--active {
  color: #1a1a1a;
  font-weight: 600;
}

.m-login__sub-tab--active::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 28px;
  height: 3px;
  background: #0091EA;
  border-radius: 2px;
}

/* ========== 表单 ========== */
.m-login__form {
  display: flex;
  flex-direction: column;
}

.m-login__field {
  margin-bottom: 14px;
  border-radius: 12px;
  overflow: hidden;
  background: #F8FAFC;
  padding-right: 0 !important;
}

/* 关键：让 Field 的右侧内容在文本框内部 */
.m-login__field::v-deep .van-field__body {
  position: relative;
  width: 100%;
}

.m-login__field::v-deep .van-field__control {
  padding-right: 36px !important;
}

/* 右侧图标容器 - 定位在文本框内部右侧 */
.m-login__field::v-deep .van-field__right-icon {
  position: absolute !important;
  right: 12px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  z-index: 10 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 18px !important;
  color: #999 !important;
  pointer-events: auto !important;
  cursor: pointer !important;
}

/* 清除按钮（叉号）- 定位在文本框内部右侧 */
.m-login__field::v-deep .van-field__clear {
  position: absolute !important;
  right: 12px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  z-index: 10 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 16px !important;
  color: #ccc !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* 当同时有清除和右图标时，调整位置 */
.m-login__field::v-deep .van-field__clear + .van-field__right-icon {
  right: 40px !important;
}

.m-login__field--password::v-deep .van-field__right-icon {
  color: #666 !important;
  font-size: 18px !important;
}

.m-login__field--code {
  flex: 1;
}

/* 验证码行 */
.m-login__code-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 14px;
}

.m-login__code-btn {
  flex-shrink: 0;
  height: 44px;
  border-radius: 12px;
  white-space: nowrap;
}

/* 验证码图片 */
.m-login__captcha-image {
  width: 80px;
  height: 44px;
  flex-shrink: 0;
  margin-left: -4px;
  cursor: pointer;
  border-radius: 12px;
  overflow: hidden;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.m-login__captcha-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.captcha-placeholder {
  font-size: 12px;
  color: #999;
  text-align: center;
}

.m-login__captcha-image:hover .captcha-placeholder {
  color: #0091EA;
}

/* 选项行 */
.m-login__options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 0 4px;
}

.m-login__options ::v-deep .van-checkbox__label {
  font-size: 13px;
  color: #666;
}

.m-login__forgot {
  font-size: 13px;
  color: #0091EA;
}

/* 同意协议 */
.m-login__agree {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.m-login__agree-text {
  font-size: 13px;
  color: #888;
  margin-left: 8px;
}

/* 密码提示 */
.m-login__pwd-hint {
  font-size: 12px;
  color: #999;
  margin: -8px 4px 14px;
  line-height: 1.5;
}

/* 提交按钮 */
.m-login__submit {
  height: 48px;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 4px;
  border: none;
}

/* 忘记密码标题 */
.m-login__forgot-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.m-login__back {
  text-align: center;
  margin-top: 16px;
  font-size: 14px;
  color: #0091EA;
}

/* 注册成功 */
.m-login__success {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0;
}

.m-login__success-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin-top: 16px;
  margin-bottom: 8px;
}

.m-login__success-sub {
  font-size: 14px;
  color: #999;
  margin-bottom: 28px;
}

/* 第三方登录 */
.m-login__third {
  margin-top: auto;
  padding: 30px 0 20px;
}

.m-login__third-line {
  text-align: center;
  margin-bottom: 16px;
}

.m-login__third-text {
  font-size: 12px;
  color: #ccc;
}

.m-login__third-icons {
  display: flex;
  justify-content: center;
  gap: 28px;
}

.m-login__third-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 协议链接 */
.m-login__link {
  color: #0091EA;
}

/* 协议弹窗 */
.m-login__agreement-popup {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.m-login__agreement-header {
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
  padding: 16px;
  border-bottom: 1px solid #ebedf0;
  flex-shrink: 0;
}

.m-login__agreement-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  -webkit-overflow-scrolling: touch;
  font-size: 14px;
  line-height: 1.8;
  color: #333;
}

.m-login__agreement-body h1 {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 2px solid #B91816;
}

.m-login__agreement-body h2 {
  font-size: 16px;
  color: #B91816;
  margin: 20px 0 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.m-login__agreement-body p {
  margin-bottom: 8px;
  text-align: justify;
  font-size: 13px;
  line-height: 1.7;
}

.m-login__agreement-body ol {
  margin-left: 20px;
  margin-bottom: 8px;
}

.m-login__agreement-body li {
  margin-bottom: 6px;
  font-size: 13px;
  line-height: 1.7;
}

.m-login__agreement-body .highlight-box {
  background-color: #FFF3CD;
  border-left: 3px solid #FFC107;
  padding: 10px 12px;
  margin-bottom: 12px;
  border-radius: 4px;
  font-size: 13px;
}

.m-login__agreement-body .info-box {
  background-color: #E7F3FF;
  border-left: 3px solid #2196F3;
  padding: 10px 12px;
  margin-bottom: 12px;
  border-radius: 4px;
  font-size: 13px;
}

.m-login__agreement-body .meta-info {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;
  color: #666;
  font-size: 12px;
}
</style>